import { MAP_PERSIAN_TO_ENGLISH } from "../StaticData";
import { GeneralObject } from "../types/General";

export function extractNestedValue<T>(item: T, nestedKeys: string) {
    const nestedKeysArray = nestedKeys.split('.')

    var currentObject = removeReference(item);
    nestedKeysArray.forEach((key) => currentObject = currentObject[key as keyof T] as T)

    return currentObject;
}

export function removeReference<T>(object: T) {
    if (!object)
        return {} as T;

    const newObject = {} as T;
    Object.keys(object || {}).forEach((key) => {
        newObject[key as keyof T] = object[key as keyof T]
    })

    return newObject;
}

export function convertPersianNumberToEnglish(persian: string, toString: boolean = false) : string | number {
    if ((persian === '' || !persian) && toString)
        return '';
    
    const ref = '۰۱۲۳۴۵۶۷۸۹';
    let result = ''
    for (let i = 0; i < persian.length; i++)
        result += ref.indexOf(persian[i]) === -1 ? persian[i] : ref.indexOf(persian[i]);
    
    return toString ? result : Number(result)
}

export function range(count: number) {
    return Array.from(Array(count).keys());
}

export function getFileExtension(name: string) {
    return /(?:\.([^.]+))?$/.exec(name)?.[1];
}

export function bindDataToId<T>(data: T[], idKey: string) {
    const boundData = {} as GeneralObject<T>;
    data.forEach((item, index) => {
        const currentKey = idKey === 'index' ? index.toString() : extractNestedValue(item, idKey) as string;
        boundData[currentKey] = item;
    })

    return boundData;
}

export function extractSearchParams() {
    const urlData = {} as GeneralObject<string>;
    window.location.search.substring(1).split('&').forEach((param) => {
        const separatorPosition = param.indexOf('=');
        urlData[param.substring(0, separatorPosition)] = param.substring(separatorPosition + 1);
    })

    return urlData;
}

export function populateListFromIds<T>(data: T[], idKey: keyof T, labelKey: keyof T, idsList: string) {
    const toArray = idsList?.split(',');
    let toString = '';

    const currentContacts = data.filter((item) => {
        const isFound = toArray?.includes(Number(item[idKey]).toString());
        
        if (isFound) 
            toString += ((item[labelKey] as string) +  ',');
        
        return isFound;
    });

    return { list: currentContacts, toString: toString }
}

export function convertPersianWordToEnglish(persian: string) {
    let result = '';
    for (let i = 0; i < persian.length; i++) {
        const ascii = persian.charCodeAt(i);
        if (ascii >= 47 && ascii <= 122)
            result += persian[i];
        else 
            result += ((MAP_PERSIAN_TO_ENGLISH as GeneralObject<string>)[persian[i]] || '');
    }

    return result;
}

export function convertEnglishNumberToPersian(input: string, toString: boolean = false) : string | number {
    if ((input === '' || !input) && toString)
        return '';
    
    const persian = '۰۱۲۳۴۵۶۷۸۹';
    const english = '0123456789';
    let result = '';
    for (let i = 0; i < input.length; i++)
        result += english.indexOf(input[i]) === -1 ? input[i] : persian[english.indexOf(input[i])];
    
    return toString ? result : Number(result)
}

export async function blob2uint(blob: Blob){
    const buffer = await new Response(blob).arrayBuffer();
    const uint = new Uint8Array(buffer);

    return uint;
}

export function copy(code: string | null | undefined, onSuccues: () => void, onError: () => void) {
    if (code) {
        try {
            navigator.clipboard.writeText(code);
            onSuccues();
        } catch (e) {
            onError();
        }
    }
}

export function generateMockArray(item: any, count: number) {
    const result = [];
    for (let i = 0; i < count; i++) {
        result.push(item)
    }

    return result;
}